import ReactDOM from 'react-dom/client';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom';
import { AzureAD } from 'react-aad-msal';
import { msalAuthProvider } from './components/contexts/AuthContext';
import { LicenseManager, AllEnterpriseModule } from  'ag-grid-enterprise';
import { ModuleRegistry } from 'ag-grid-community';
import config from './config.json';

LicenseManager.setLicenseKey(config.agGrid.license);
ModuleRegistry.registerModules([AllEnterpriseModule]);

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');

ReactDOM
.createRoot(document.getElementById('root'))
.render(
    <AzureAD provider={msalAuthProvider} forceLogin={true}>
        <BrowserRouter basename={baseUrl}>
            <App />
        </BrowserRouter>
    </AzureAD>
);

//registerServiceWorker();